






































import { Vue, Component, Prop } from 'vue-property-decorator'
import { Schedule } from '@/types/schedule'
import UserIcon from '../common/UserIcon.vue'
import ScheduleTypeIcon from './ScheduleTypeIcon.vue'
import { eventType2Css } from '@/utils/schedule'
import { ScheduleEventType } from '@/constants/schedule'

@Component({
  components: { UserIcon, ScheduleTypeIcon }
})
export default class ScheduleListItem extends Vue {
  @Prop({ default: {} })
  schedule!: Schedule

  get worker() {
    return this.schedule.worker
  }

  get patient() {
    return this.schedule.patient
  }

  get startTime() {
    const { startHour, startMinute } = this.schedule
    return `${('0' + startHour).slice(-2)}:${('0' + startMinute).slice(-2)}`
  }

  get eventTypeCss() {
    const eventType = (
      this.schedule.eventType || ''
    ).trim() as ScheduleEventType
    return eventType2Css(eventType)
  }
}
